import { Language } from "@/services/i18n/slice/types";

const Config = {
  CRESCENDO: {
    name: "Crescendo",
    title: "Crescendo.People",
    favicon: require("@/shared/assets/crescendo-favicon.ico"),
    logo: "CrescendoIcon",
    background: `url(${require("@/shared/assets/crescendo_registration_page_background.png")}), radial-gradient(50.59% 101.17% at 100% 101.17%, #0E2D58 0%, #000205 100%)`,
    backgroundMobile: `linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%), url(${require("@/shared/assets/crescendo_registration_page_background_mobile_transparent.png")}), radial-gradient(ellipse at 93.5% 12.44%, #0e2d58 0%, #061b34 40%, #020b16 75%, #000205 100%)`,
    backgroundMobileSize: "contain",
    phoneRegex: /^(?!\+79|89)(\+\d{2}\d{8,13})$/,
    defaultLang: Language.EN,
    langKey: "en",
    telegramSupport: "C_People_Support_Bot",
    mailSupport: "people_support@crescendo.ae",
    privacyPolicy: "http://people.crescendo.ae/privacypolicy",
    termsConditions: "http://people.crescendo.ae/licenseagreement",
    landing: "https://people.crescendo.ae/",
    saasRedirect: "https://app.people.crescendo.ae/",
  },
  PEOPLE: {
    name: "Umarta",
    title: "Umarta.People",
    favicon: require("@/shared/assets/umarta-favicon.ico"),
    logo: "LogoIconV2",
    background: `linear-gradient(255deg, rgba(42, 61, 89, 0.2) 10.16%, #020a16 58.91%), url(${require("@/shared/assets/umarta_registration_page_background.png")})`,
    backgroundMobile: `linear-gradient(255deg, rgba(42, 61, 89, 0.2) 10.16%, #020a16 58.91%), url(${require("@/shared/assets/umarta_registration_page_background.png")})`,
    backgroundMobileSize: "cover",
    phoneRegex: /^\+\d{2}\d{9}$/,
    //phoneRegex: /^\+79\d{9}$/,
    defaultLang: Language.RU,
    langKey: "ru",
    telegramSupport: "U_People_Support_Bot",
    mailSupport: "help_people@umarta.dev",
    privacyPolicy: "https://umarta.dev/privacy_policy",
    termsConditions: "https://people.umarta.dev/licenseagreement",
    landing: "https://people.umarta.dev/",
    saasRedirect: "https://ru.people.umarta.dev/",
  },
};

export const installationConfig = Config[window.__RUNTIME_CONFIG__.INSTALLATION_TYPE ?? "PEOPLE"];
